import moment from "moment";

type WeeklyData = {
    period: string;
    sales: number;
};

export type TransformWeeksToMonthlySales = {
    year: string;
    monthlyDemand: { month: number; quantity: number };
    weeklyDemand: { week: number; quantity: number }[];
};
export const transformWeeklyToMonthlySales = (
    weeklyData: WeeklyData[]
): TransformWeeksToMonthlySales[] => {
    const monthlyData: TransformWeeksToMonthlySales[] = [];

    // Group weeks by month
    const monthGroups = new Map<number, WeeklyData[]>();

    weeklyData.forEach((weekData) => {
        const date = new Date(weekData.period);
        const month = date.getMonth() + 1; // getMonth() returns 0-11, so add 1

        if (!monthGroups.has(month)) {
            monthGroups.set(month, []);
        }
        monthGroups.get(month)!.push(weekData);
    });

    monthGroups.forEach((weeks, month) => {
        const totalQuantity = weeks.reduce((sum, week) => sum + week.sales, 0);

        monthlyData.push({
            year: moment(weeks[0].period).format("YYYY-MM-DD"),
            monthlyDemand: {
                month: month,
                quantity: Math.round(totalQuantity || 0),
            },
            weeklyDemand: weeks.map((week, index) => ({
                week: index + 1, // Week number within the month (1-4)
                quantity: Math.round(week.sales || 0),
            })),
        });
    });

    // Sort by month
    return monthlyData.sort((a, b) => a.monthlyDemand.month - b.monthlyDemand.month);
};
